
import { Component, Prop, Vue } from 'vue-property-decorator';
import kebabCase from 'lodash/kebabCase';
import { mapState } from 'vuex';
import HasScope from '@/components/Mixins/HasScope';
import { Item } from '@/views/interfaces/vuetify/item.interface';
import NavigationRelatedTabs from '@/plugins/navigation-relations';

@Component({
  mixins: [
    HasScope,
  ],
  computed: {
    ...mapState(['barColor']),
  },
  inheritAttrs: false,
})
export default class ItemGroup extends Vue {

  @Prop({
    type: Object, default: (): Item => ({
      avatar: '',
      group: '',
      title: '',
      scope: '',
      to: '',
      children: [],
    }),
  }) private readonly item!: Item;
  @Prop({ type: Boolean, default: false }) private readonly subGroup!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly text!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly expandOnHover!: boolean;
  @Prop() private readonly drawer!: any;

  get children(): Item[] {
    if (!this.item.children) {
      return [];
    }

    return this.item.children.map((item: Item) => {
      let route = this.item.group;
      if (item.to) {
        route += `${item.to}`;
      }

      return {
        ...item,
        to: route,
      };
    });
  }

  get computedText(): string {
    if (!this.item || !this.item.title) {
      return '';
    }

    let text = '';

    this.item.title.split(' ').forEach((val: string) => {
      text += val.substring(0, 1);
    });

    return text;
  }

  get group(): string {
    return this.genGroup(this.item.children ?? []);
  }

  private genGroup(children: Item[]): string {
    return children
      .filter((item: Item) => item.to || item.toFixed)
      .map((item: Item) => {
        const parent = item.group || this.item.group;
        let group = parent;
        if (item.to) {
          group = `${parent}/${kebabCase(item.to)}`;
        }

        if (item.toFixed) {
          group = item.toFixed;
        }

        if (item.children) {
          group = `${group}|${this.genGroup(item.children)}`;
        }
        return group;
      }).join('|');
  }

  private getActiveTab(item: Item): boolean {
    const tabPath = item.toFixed || item.to;
    if (!tabPath) {
      return false;
    }

    const tabRelations = NavigationRelatedTabs.get(tabPath);
    if (!tabRelations) {
      return false;
    }

    const currentPath = this.$route.path;
    const currentPathParams = Object.values(this.$route.params);

    if (currentPathParams.length > 0) {
      const urlIncludesSomeParam = currentPathParams.some((param) => currentPath.includes(param));
      return (urlIncludesSomeParam && tabRelations.includes(currentPath.substr(0, currentPath.lastIndexOf('/'))))
        || tabRelations.includes(currentPath);
    }

    return tabRelations.includes(currentPath);
  }
}
